import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import { LINKEDIN_CAMPAIGN_OBJECTIVE, LINKEDIN_CAMPAIGN_TYPE, LINKEDIN_OPTIMIZATION_TARGET_TYPE } from '../SocialMediaConstant';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const LinkedinCampaignForm = ({ dataItem, setDataItem, budgetData, minSpendCap }) => {

    const lang = useTranslation();
    const [types, setTypes] = useState([]);
    const [objectiveTypes, setObjectiveTypes] = useState([]);
    const [costTypes, setCostTypes] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let typeRes = Object.keys(LINKEDIN_CAMPAIGN_TYPE).map(key => ({
            _id: LINKEDIN_CAMPAIGN_TYPE[key],
            description: key
        }));
        setTypes(typeRes);
        let objectiveTypeRes = Object.keys(LINKEDIN_CAMPAIGN_OBJECTIVE).map(key => ({
            _id: LINKEDIN_CAMPAIGN_OBJECTIVE[key],
            description: key
        }));
        setObjectiveTypes(objectiveTypeRes);
        let costTypeRes = Object.keys(LINKEDIN_OPTIMIZATION_TARGET_TYPE).map(key => ({
            _id: LINKEDIN_OPTIMIZATION_TARGET_TYPE[key],
            description: key
        }));
        setCostTypes(costTypeRes);
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    return (
        <div className="row p-2">
            {/* costType */}
            <div className="col-6">
                <label htmlFor="costType" className="form-label">{lang.cost_type_label} *</label>
                <DropDownList
                    name="costType"
                    textField="description"
                    dataItemKey="_id"
                    data={costTypes}
                    value={dataItem.costType}
                    onChange={onChange}
                />
            </div>
            <div className="col-6">
                <label htmlFor="objectiveType" className="form-label">{lang.objective_type_label} *</label>
                <DropDownList
                    name="objectiveType"
                    textField="description"
                    dataItemKey="_id"
                    data={objectiveTypes}
                    value={dataItem.objectiveType}
                    onChange={onChange}
                />
            </div>
            <div className="col-6 mt-2">
                <label htmlFor="type" className="form-label">{lang.type_label} *</label>
                <DropDownList
                    name="type"
                    textField="description"
                    dataItemKey="_id"
                    data={types}
                    value={dataItem.type}
                    onChange={onChange}
                />
            </div>
            <div className="col-6 mt-2">
                <label htmlFor="spend_cap" className="form-label">{lang.spend_cap_label} *</label>
                <input
                    type="number"
                    name="spend_cap"
                    className="form-control form-control-sm"
                    placeholder="Enter Spend Cap"
                    value={dataItem.spend_cap}
                    onChange={onChange}
                />
                {/* <small className="form-text text-muted">
                    {`Minimum Spend Cap >= ${budgetData?.currency?.Description} ${minSpendCap}`}
                </small> */}
            </div>
            <div className="col-6 mt-2">
                <label htmlFor="daily_budget" className="form-label">{lang.daily_budget_label} *</label>
                <input
                    type="text"
                    name="daily_budget"
                    className='form-control form-control-sm'
                    placeholder="Enter Daily Budget"
                    value={dataItem.daily_budget}
                    onChange={onChange}
                />
            </div>
        </div>

    )
}

export default LinkedinCampaignForm;